import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Joyride from "react-joyride";
import useFetchUser from "hooks/useFetchUser";
import {
  positionBeaconOnOpenPanneau,
  positionBeaconOnImportData,
  getFallbackPosition
} from "utils/beaconPositioning";
import {
  debugLog,
  logBeaconVisibility
} from "utils/beaconDebug";

// Standalone Beacon Component for showing next tour indicators
const StandaloneBeacon = ({ route }) => {
  const { startTourForRoute, hideBeaconForRoute, setFocusMode, focusModeOptions } = useTour();
  const [showBeacon, setShowBeacon] = useState(false);
  const [beaconPosition, setBeaconPosition] = useState({ top: '300px', left: '20px' });
  const [isPositioned, setIsPositioned] = useState(false);
  const navigate = useNavigate();
  const userInfo = useFetchUser();
  
  // State to track if user has clicked on the import data beacon
  const [importDataClicked, setImportDataClicked] = useState(() => {
    return localStorage.getItem('tour_import_data_clicked') === 'true';
  });
  
  // State to track if user has clicked on the open panneau beacon
  const [openPanneauClicked, setOpenPanneauClicked] = useState(() => {
    return localStorage.getItem('tour_open_panneau_clicked') === 'true';
  });

  // Optimized beacon positioning using the new utility
  // const positionBeacon = useCallback(() => {
  //   // If user has already clicked on import data, show beacon for open panneau
  //   if (importDataClicked && !openPanneauClicked && route.startsWith('/talent/dataimport')) {
  //     debugLog("Attempting to position beacon on open panneau button");
      
  //     const position = positionBeaconOnOpenPanneau();
  //     if (position) {
  //       setBeaconPosition(position);
  //       setIsPositioned(true);
  //       debugLog("Beacon positioned on open panneau button:", position);
  //       return true;
  //     } else {
  //       debugLog("Could not find open panneau button for positioning beacon");
  //       return false;
  //     }
  //   }
    
  //   // Otherwise, show beacon for import data navigation item
  //   debugLog("Attempting to position beacon on import data navigation item");
  //   const position = positionBeaconOnImportData();
  //   if (position) {
  //     setBeaconPosition(position);
  //     setIsPositioned(true);
  //     debugLog("Beacon positioned on nav item:", position);
  //     return true;
  //   } else {
  //     debugLog("Could not find nav item for positioning beacon");
  //     return false;
  //   }
  // }, [importDataClicked, openPanneauClicked, route]);
//------------------------------showing Beacon-------------------------------------------------------------------
  // Show beacon for dataimport - but only on routes where the navigation is visible
  // useEffect(() => {
  //   // Show first beacon on routes where navigation sidebar is present, but NOT on the dataimport page itself
  //   const shouldShowFirstBeacon = !route.startsWith('/talent/dataimport') && route.startsWith('/talent/');
  //   // Show second beacon ONLY on dataimport page after first beacon is clicked
  //   const shouldShowSecondBeacon = route.startsWith('/talent/dataimport') && importDataClicked && !openPanneauClicked;
    
  //   // Check if user data is loaded and if they are a first-time user
  //   let isFirstTimeUser = null;
    
  //   // Handle case where userInfo might not be loaded yet
  //   if (userInfo.loading) {
  //     debugLog("User data still loading, checking localStorage for first_time status");
  //     // Try to get from localStorage as fallback
  //     const storedFirstTime = localStorage.getItem('user_is_first_time');
  //     if (storedFirstTime !== null) {
  //       isFirstTimeUser = storedFirstTime === 'true';
  //       debugLog("Using stored first_time value:", isFirstTimeUser);
  //     }
  //   } else if (userInfo.formData && typeof userInfo.formData.first_time !== 'undefined') {
  //     isFirstTimeUser = userInfo.formData.first_time === true;
  //     // Store in localStorage for future reference
  //     localStorage.setItem('user_first_time_checked', 'true');
  //     localStorage.setItem('user_is_first_time', userInfo.formData.first_time.toString());
  //     debugLog("Using userInfo first_time value:", isFirstTimeUser);
  //   } else if (localStorage.getItem('user_first_time_checked') === 'true') {
  //     // If we've checked this before, use the stored value
  //     isFirstTimeUser = localStorage.getItem('user_is_first_time') === 'true';
  //     debugLog("Using stored first_time value from previous check:", isFirstTimeUser);
  //   }
    
  //   const visibilityConditions = { 
  //     route, 
  //     shouldShowFirstBeacon,
  //     shouldShowSecondBeacon,
  //     isFirstTimeUser,
  //     userInfoLoading: userInfo.loading,
  //     importDataClicked,
  //     openPanneauClicked
  //   };
    
  //   logBeaconVisibility('dataimport', shouldShowFirstBeacon || shouldShowSecondBeacon, visibilityConditions);
    
  //   // Only show first beacon for first-time users who haven't clicked on import data yet
  //   // If we don't have user data yet, we'll wait and check again
  //   if (shouldShowFirstBeacon) {
  //     if (isFirstTimeUser === true && !importDataClicked) {
  //       debugLog("Conditions met to show beacon for dataimport navigation item");
        
  //       // Show beacon immediately for better performance
  //       debugLog("Showing beacon for dataimport navigation item");
  //       setShowBeacon(true);
        
  //       // Try to position the beacon immediately
  //       const positioned = positionBeacon();
        
  //       // If not positioned yet, use fallback position
  //       if (!positioned) {
  //         debugLog("Beacon not positioned initially, using fallback position");
  //         const fallbackPosition = getFallbackPosition(false);
  //         setBeaconPosition(fallbackPosition);
  //       }
  //     } else if (isFirstTimeUser === null) {
  //       // User data not loaded yet, set up a quick check
  //       debugLog("User data not loaded yet, setting up quick check");
  //       const checkTimeout = setTimeout(() => {
  //         // Let the effect run again by triggering a re-render if needed
  //       }, 100); // Reduced timeout for better performance
        
  //       return () => {
  //         clearTimeout(checkTimeout);
  //       };
  //     } else {
  //       debugLog("Beacon conditions not met for first beacon:", { 
  //         shouldShowFirstBeacon, 
  //         isFirstTimeUser,
  //         importDataClicked 
  //       });
  //     }
  //   } 
  //   // Show second beacon on dataimport page
  //   else if (shouldShowSecondBeacon) {
  //     debugLog("Conditions met to show beacon for open panneau button");
      
  //     // Show beacon immediately for better performance
  //     debugLog("Showing beacon for open panneau button");
  //     setShowBeacon(true);
      
  //     // Try to position the beacon immediately
  //     const positioned = positionBeacon();
      
  //     // If not positioned yet, use fallback position
  //     if (!positioned) {
  //       debugLog("Beacon not positioned initially, using fallback position");
  //       const fallbackPosition = getFallbackPosition(true);
  //       setBeaconPosition(fallbackPosition);
  //     }
  //   }
    
  //   // Hide beacon if conditions are not met
  //   if (showBeacon && !shouldShowFirstBeacon && !shouldShowSecondBeacon) {
  //     debugLog("Hiding beacon, conditions not met");
  //     setShowBeacon(false);
  //   }
  // }, [route, positionBeacon, userInfo, importDataClicked, openPanneauClicked, showBeacon]);

  const handleBeaconClick = () => {
    debugLog("Beacon clicked");
    
    // Disable focus mode when beacon is clicked
    setFocusMode(false);
    
    // If this is the import data beacon (first beacon)
    if (!importDataClicked) {
      debugLog("First beacon clicked - navigating to dataimport page");
      // Mark as clicked
      setImportDataClicked(true);
      localStorage.setItem('tour_import_data_clicked', 'true');
      // Hide the beacon
      setShowBeacon(false);
      // Navigate to dataimport page
      navigate('/talent/dataimport');
      return;
    }
    
    // If this is the open panneau beacon (second beacon)
    if (importDataClicked && !openPanneauClicked) {
      debugLog("Second beacon clicked - opening panneau and starting tour");
      // Mark as clicked
      setOpenPanneauClicked(true);
      localStorage.setItem('tour_open_panneau_clicked', 'true');
      // Hide the beacon
      setShowBeacon(false);
      hideBeaconForRoute(route);
      
      // Find and click the open panneau button
      const openPanneauButton = document.querySelector('.openPaneau');
      if (openPanneauButton) {
        openPanneauButton.click();
      }
      
      // Start the tour after a small delay to allow UI to update
      setTimeout(() => {
        startTourForRoute('/talent/dataimport');
      }, 200); // Reduced delay for better performance
    }
  };

  // Only render beacon if it should be shown
  if (!showBeacon) {
    return null;
  }

  debugLog("Rendering beacon at position:", beaconPosition);
  
  // Render a beacon positioned on the sidebar navigation item
  return (
    <>
      {/* Focus overlay to disable all other UI elements */}
      <div 
        className="focus-overlay"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: focusModeOptions.overlayColor,
          zIndex: 10000,
          pointerEvents: 'none', // Allow clicks to pass through to the beacon
        }}
      />
      
      {/* The beacon itself - simplified structure for better performance */}
      <div 
        className="tour-beacon"
        // onClick={handleBeaconClick}
        style={{
          position: 'fixed',
          top: beaconPosition.top,
          left: beaconPosition.left,
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          backgroundColor: '#ff6b35',
          cursor: 'pointer',
          zIndex: 10001,
          animation: 'pulse 2s infinite',
          boxShadow: '0 0 0 0 rgba(255, 107, 53, 0.7)',
          transform: 'translate(-50%, -50%)', // Center the beacon on the position
          opacity: isPositioned ? 1 : 0.7, // Show with reduced opacity until properly positioned
          transition: 'opacity 0.3s ease-in-out',
        }}
      >
        <style>
          {`
            @keyframes pulse {
              0% {
                box-shadow: 0 0 0 0 rgba(255, 107, 53, 0.7);
              }
              70% {
                box-shadow: 0 0 0 10px rgba(255, 107, 53, 0);
              }
              100% {
                box-shadow: 0 0 0 0 rgba(255, 107, 53, 0);
              }
            }
          `}
        </style>
      </div>
    </>
  );
};

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const location = useLocation();
  const [currentTour, setCurrentTour] = useState(null);
  const [currentRoute, setCurrentRoute] = useState(null);
  const [runTour, setRunTour] = useState(false);
  const [tourSteps, setTourSteps] = useState([]);
  const [completedTours, setCompletedTours] = useState(() => {
    // Initialize completed tours from localStorage
    const completed = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('tour_')) {
        completed[key.replace('tour_', '')] = true;
      }
    }
    return completed;
  });
  const [showBeacon, setShowBeacon] = useState({});
  const { t } = useTranslation();
  
  // Focus mode state with customization options
  const [focusMode, setFocusMode] = useState(false);
  const [focusModeOptions, setFocusModeOptions] = useState({
    overlayColor: 'rgba(0, 0, 0, 0.5)',
    allowClickThrough: false,
    highlightBeacon: true,
    disableScroll: false
  });
  
  // Add/remove focus-mode class to body when focusMode changes
  useEffect(() => {
    let focusModeTimeout;
    
    if (focusMode) {
      document.body.classList.add('focus-mode');
      // Apply custom styles
      const style = document.createElement('style');
      style.id = 'tour-focus-mode-styles';
      style.innerHTML = `
        body.focus-mode *:not(.tour-beacon):not(.tour-beacon *) {
          pointer-events: ${focusModeOptions.allowClickThrough ? 'auto' : 'none'} !important;
        }
        
        body.focus-mode .tour-beacon,
        body.focus-mode .tour-beacon * {
          pointer-events: auto !important;
        }
        
        body.focus-mode .focus-overlay {
          background-color: ${focusModeOptions.overlayColor} !important;
        }
        
        body.focus-mode {
          overflow: ${focusModeOptions.disableScroll ? 'hidden' : 'auto'};
        }
      `;
      document.head.appendChild(style);
      
      // Failsafe: disable focus mode after 60 seconds
      focusModeTimeout = setTimeout(() => {
        console.log('Failsafe: Disabling focus mode after 60 seconds');
        setFocusMode(false);
      }, 60000);
    } else {
      document.body.classList.remove('focus-mode');
      // Remove custom styles
      const style = document.getElementById('tour-focus-mode-styles');
      if (style) {
        style.remove();
      }
    }
    
    // Cleanup function
    return () => {
      document.body.classList.remove('focus-mode');
      const style = document.getElementById('tour-focus-mode-styles');
      if (style) {
        style.remove();
      }
      if (focusModeTimeout) {
        clearTimeout(focusModeTimeout);
      }
    };
  }, [focusMode, focusModeOptions]);
  
  // Cleanup focus mode when location changes (navigating away from current page)
  useEffect(() => {
    // Disable focus mode when navigating to a different route
    setFocusMode(false);
  }, [location.pathname, setFocusMode]);
  
  // Refs to store function references to avoid circular dependencies
  const hideBeaconForRouteRef = useRef();
  const showBeaconForRouteRef = useRef();
  const cleanupWildcardToursRef = useRef();

  // ✅ Move TOUR_STEPS inside provider, wrapped in useMemo so it’s stable
  const TOUR_STEPS = useMemo(
    () => ({
      '/dashboardqq': [
        {
          target: '.nav-item-dashboard',
          content: t('tour.welcome'),
          title: t('tour.Dashboard Navigation'),
          placement: 'left',
          disableBeacon: true,
          showSkipButton: false,
        },
        {
          target: '.dashboard-cards',
          content: t('tour.cards'),
          title: t('tour.Key Metrics Overview'),
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '.dashboard-card-1',
          content: t('tour.card1'),
          title: t('tour.Offers Posted'),
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '.dashboard-card-2',
          content: t('tour.card2'),
          title: t('tour.Total Applicants'),
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '.dashboard-card-3',
          content: t('tour.card3'),
          title: t('tour.Total Candidates'),
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '.dashboard-card-4',
          content: t('tour.card4'),
          title: t('tour.Interviews Conducted'),
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '.dashboard-card-5',
          content: t('tour.card5'),
          title: t('tour.Acceptances'),
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '.dashboard-card-6',
          content: t('tour.card6'),
          title: t('tour.Hires'),
          placement: 'bottom',
          disableBeacon: true,
        },
      ],
      '/talent/dataimportqq': [
        {
          target: '#subcategory-select',
          content: t('tour.subcategorySelect') || 'Select a subcategory for more precise classification.',
          title: t('tour.Subcategory Selection') || 'Subcategory Selection',
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '#file-upload',
          content: t('tour.fileUpload') || 'Click here or drag and drop your PDF files to import them.',
          title: t('tour.File Upload') || 'File Upload',
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '.start-extraction-button',
          content: t('tour.startExtraction') || 'Start email extraction to automatically retrieve applications.',
          title: t('tour.Email Extraction') || 'Email Extraction',
          placement: 'bottom',
          disableBeacon: true,
        },
      ],
    }),
    [t]
  );

  useEffect(() => {
    console.log("TourProvider: useEffect - location changed:", location.pathname);

    // Check if we have a tour for the current route
    if (TOUR_STEPS[location.pathname]) {
      console.log("TourProvider: Tour found for route:", location.pathname);

      // If we're not already on the same tour
      if (currentTour !== location.pathname) {
        console.log("TourProvider: Starting new tour for route:", location.pathname);

        // Update current tour and route
        setCurrentTour(location.pathname);
        setCurrentRoute(location.pathname);
        setRunTour(true);

        // Set tour steps for the current route
        setTourSteps(TOUR_STEPS[location.pathname]);

        // Clear completed tour state for this route
        setCompletedTours((prevCompletedTours) => {
          const updatedTours = { ...prevCompletedTours };
          delete updatedTours[location.pathname];
          return updatedTours;
        });
      }
    } else {
      console.log("TourProvider: No tour found for route:", location.pathname);

      // If we were on a tour before, end it
      if (currentTour) {
        console.log("TourProvider: Ending current tour:", currentTour);

        // Clear current tour and route
        setCurrentTour(null);
        setCurrentRoute(null);
        setRunTour(false);
        setTourSteps([]);
      }
    }
  }, [location.pathname, TOUR_STEPS, currentTour]);

  const handleAfterAll = useCallback((data) => {
    const { status, type } = data;
    
    // Only mark tour as completed when it's actually finished or skipped by the user
    if (status === 'finished' || status === 'skipped') {
      console.log("TourProvider: Tour completed for route:", currentRoute);
      
      // Disable focus mode when tour is completed
      setFocusMode(false);
      
      // Check if we've already marked this tour as completed to prevent infinite loops
      const tourAlreadyCompleted = localStorage.getItem(`tour_${currentRoute}_completed`);
      if (tourAlreadyCompleted === 'true') {
        console.log("TourProvider: Tour already marked as completed, skipping");
        return;
      }
      
      // Mark the tour as completed
      setCompletedTours((prevCompletedTours) => ({
        ...prevCompletedTours,
        [currentRoute]: true,
      }));
      
      // Save completion status to localStorage
      if (currentRoute) {
        localStorage.setItem(`tour_${currentRoute}`, 'true');
        localStorage.setItem(`tour_${currentRoute}_completed`, 'true');
      }
      
      // If this is the dataimport tour, update the user's first_time status
      if (currentRoute === '/talent/dataimport') {
        // Check if we've already dispatched this event
        const eventAlreadyDispatched = localStorage.getItem('tour_completed_event_dispatched');
        if (!eventAlreadyDispatched) {
          console.log("TourProvider: Dispatching tourCompleted event for dataimport");
          // Dispatch a custom event to notify the DataImport component
          window.dispatchEvent(new CustomEvent('tourCompleted', { detail: { route: currentRoute } }));
          // Mark that we've dispatched the event
          localStorage.setItem('tour_completed_event_dispatched', 'true');
        } else {
          console.log("TourProvider: tourCompleted event already dispatched, skipping");
        }
      }
      
      // Clear current tour and route
      setCurrentTour(null);
      setCurrentRoute(null);
      setRunTour(false);
      setTourSteps([]);
    }
  }, [currentRoute, setFocusMode]);

  const startTourForRoute = useCallback(
    (route) => {
      console.log("TourProvider: Starting tour for route:", route);

      // Check localStorage for completion status
      const localStorageKey = `tour_${route}`;
      const isCompletedInStorage = localStorage.getItem(localStorageKey) === 'true';
      
      // If the tour is already completed, don't start it again
      if (completedTours[route] || isCompletedInStorage) {
        console.log("TourProvider: Tour already completed for route:", route);
        return;
      }

      // Update current tour and route
      setCurrentTour(route);
      setCurrentRoute(route);
      setRunTour(true);

      // Set tour steps for the current route
      setTourSteps(TOUR_STEPS[route]);
    },
    [completedTours, TOUR_STEPS]
  );

  // const hideBeaconForRoute = useCallback(
  //   (route) => {
  //     console.log("TourProvider: Hiding beacon for route:", route);
  //     setShowBeacon((prevShowBeacon) => {
  //       const updatedShowBeacon = { ...prevShowBeacon };
  //       delete updatedShowBeacon[route];
  //       return updatedShowBeacon;
  //     });
  //   },
  //   [setShowBeacon]
  // );

  // const showBeaconForRoute = useCallback(
  //   (route) => {
  //     console.log("TourProvider: Showing beacon for route:", route);
  //     setShowBeacon((prevShowBeacon) => ({
  //       ...prevShowBeacon,
  //       [route]: true,
  //     }));
  //   },
  //   [setShowBeacon]
  // );

  // const cleanupWildcardTours = useCallback(() => {
  //   console.log("TourProvider: Cleaning up wildcard tours");

  //   // Remove tours that are not specific to a route
  //   const updatedCompletedTours = Object.fromEntries(
  //     Object.entries(completedTours).filter(([key]) => !key.includes('*'))
  //   );
  //   setCompletedTours(updatedCompletedTours);

  //   // Remove tour steps for wildcard tours
  //   const updatedTourSteps = Object.fromEntries(
  //     Object.entries(tourSteps).filter(([key]) => !key.includes('*'))
  //   );
  //   setTourSteps(updatedTourSteps);

  //   // Remove current tour if it's a wildcard tour
  //   if (currentTour && currentTour.includes('*')) {
  //     setCurrentTour(null);
  //     setCurrentRoute(null);
  //     setRunTour(false);
  //     setTourSteps([]);
  //   }
  // }, [completedTours, currentTour, tourSteps]);

  // const resetAllTours = useCallback(() => {
  //   console.log("TourProvider: Resetting all tours");
    
  //   // Clear all tour completion flags from localStorage
  //   for (let i = 0; i < localStorage.length; i++) {
  //     const key = localStorage.key(i);
  //     if (key && key.startsWith('tour_')) {
  //       localStorage.removeItem(key);
  //     }
  //   }
    
  //   // Reset completed tours state
  //   setCompletedTours({});
    
  //   // Clear current tour
  //   setCurrentTour(null);
  //   setCurrentRoute(null);
  //   setRunTour(false);
  //   setTourSteps([]);
  // }, []);

  // Store function references to avoid circular dependencies
  // hideBeaconForRouteRef.current = hideBeaconForRoute;
  // showBeaconForRouteRef.current = showBeaconForRoute;
  // cleanupWildcardToursRef.current = cleanupWildcardTours;
const userInfo = useFetchUser();
  // Add global function for manual testing
  useEffect(() => {
    // Expose function globally for manual testing
    window.resetFocusMode = () => {
      console.log('Manually resetting focus mode');
      setFocusMode(false);
      document.body.classList.remove('focus-mode');
      const style = document.getElementById('tour-focus-mode-styles');
      if (style) {
        style.remove();
      }
    };
    
    window.debugBeacon = () => {
      const route = window.location.pathname;
      const shouldShowBeacon = !route.startsWith('/talent/dataimport') && route.startsWith('/talent/');
      // 
      const isFirstTimeUser = userInfo.loading ? null : (userInfo.formData.first_time === true);
      const importDataClicked = localStorage.getItem('tour_import_data_clicked') === 'true';
      
      console.log("Manual beacon debug:", { 
        route, 
        shouldShowBeacon, 
        isFirstTimeUser,
        userInfoLoading: userInfo.loading,
        userInfoFormData: userInfo.formData,
        importDataClicked 
      });
      
      return {
        route,
        shouldShowBeacon,
        isFirstTimeUser,
        userInfoLoading: userInfo.loading,
        importDataClicked
      };
    };
    
    // NEW: Add a failsafe to disable focus mode on the dataimport page
    const handleLocationChange = () => {
      if (window.location.pathname.startsWith('/talent/dataimport')) {
        console.log('On dataimport page - disabling focus mode');
        setFocusMode(false);
        document.body.classList.remove('focus-mode');
        const style = document.getElementById('tour-focus-mode-styles');
        if (style) {
          style.remove();
        }
      }
    };
    
    // Check on initial load
    handleLocationChange();
    
    // Listen for popstate events (browser back/forward)
    window.addEventListener('popstate', handleLocationChange);
    
    // NEW: Also check periodically to ensure focus mode is disabled
    const interval = setInterval(() => {
      if (window.location.pathname.startsWith('/talent/dataimport') && focusMode) {
        console.log('Periodic check: Disabling focus mode on dataimport page');
        setFocusMode(false);
        document.body.classList.remove('focus-mode');
        const style = document.getElementById('tour-focus-mode-styles');
        if (style) {
          style.remove();
        }
      }
    }, 1000); // Check every second
    
    // Cleanup
    return () => {
      if (window.debugBeacon) {
        delete window.debugBeacon;
      }
      if (window.resetFocusMode) {
        delete window.resetFocusMode;
      }
      window.removeEventListener('popstate', handleLocationChange);
      clearInterval(interval); // Clear the interval
    };
  }, [focusMode]);

  const contextValue = {
    startTourForRoute,
    // hideBeaconForRoute,
    // showBeaconForRoute,
    // cleanupWildcardTours,
    // resetAllTours,
    focusMode,
    setFocusMode,
    focusModeOptions,
    setFocusModeOptions,
  };

  return (
    <TourContext.Provider value={contextValue}>
      {/* <StandaloneBeacon route={location.pathname} /> */}
      <Joyride
        steps={tourSteps}
        run={runTour}
        continuous
        showProgress
        showSkipButton
        hideBackButton
        disableScroll
        styles={{
          options: {
            zIndex: 10000,
          },
          spotlight: {
            borderRadius: 4,
          },
        }}
        locale={{
          back: t('tour.back'),
          close: t('tour.close'),
          last: t('tour.last'),
          next: t('tour.next'),
          skip: t('tour.skip'),
        }}
        callback={handleAfterAll}
      />
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => useContext(TourContext);
